import { SCENES } from './content';

// Sample stories — replace with real founding workshops as they sign off.
export const STORIES = [
  {
    slug: 'gloss-garage-indiranagar',
    workshop: 'Gloss Garage', city: 'Indiranagar, Bangalore', segment: 'Detailing & PPF studio',
    logo: { mark: 'GG', color: '#0f766e', font: 'tracking-[0.25em]' },
    owner: 'Ravi Menon', role: 'Owner', image: SCENES.ppf,
    quote: 'We used to lose a PPF job a week because nobody followed up the quote. Now every estimate has a reminder and a WhatsApp link.',
    metrics: [['+32%', 'quotes turned into jobs'], ['4 hrs', 'saved every week on billing'], ['0', 'missed warranty cards']],
    before: 'Quotes on WhatsApp, job notes on paper, and warranty cards typed in Word after the car had left.',
    changed: 'Estimates go out as branded PDFs with a pay link. The PPF warranty is issued from the invoice in one tap and the customer gets it on WhatsApp.',
    after: 'Ravi now sees every open quote on one screen and calls the warm ones each morning.',
  },
  {
    slug: 'shree-auto-body-hubli',
    workshop: 'Shree Auto Body Works', city: 'Hubballi, Karnataka', segment: 'Body shop',
    logo: { mark: 'SAB', color: '#b45309', font: 'italic' },
    owner: 'Prakash Kulkarni', role: 'Managing partner', image: SCENES.bodyshop,
    quote: 'Insurance jobs used to sit in a register for weeks. Now I can see which car is stuck at which stage before the customer calls me.',
    metrics: [['2 days', 'faster average delivery'], ['100%', 'GST invoices filed on time'], ['18', 'cars tracked at once']],
    before: 'A thick register for job status, a separate billing software for GST, and stock counted by hand at month end.',
    changed: 'Every car has a job card with photos and stages. Parts used come straight off stock, and the GST invoice is built from the job card.',
    after: 'Month-end GST takes an afternoon instead of three days with the accountant.',
  },
  {
    slug: 'motorcare-hub-mysuru',
    workshop: 'MotorCare Hub', city: 'Mysuru, Karnataka', segment: 'Multi-brand service workshop',
    logo: { mark: 'MCH', color: '#1d4ed8', font: 'font-bold' },
    owner: 'Ananya Rao', role: 'Operations head', image: SCENES.service,
    quote: 'Service reminders were the job nobody had time for. Driveline sends them, and the bay is full on Mondays now.',
    metrics: [['+41%', 'repeat service visits'], ['6', 'staff using it daily'], ['₹0', 'setup fee']],
    before: 'Customer list in an old Excel file, reminders sent only when someone remembered, attendance on a paper sheet.',
    changed: 'Bookings, reminders and feedback run from one place. Staff mark attendance on their phone and salaries are worked out for them.',
    after: 'Ananya spends her mornings on the floor instead of chasing spreadsheets.',
  },
  {
    slug: 'spares-point-chennai',
    workshop: 'Spares Point Accessories', city: 'Anna Nagar, Chennai', segment: 'Parts & accessories showroom',
    logo: { mark: 'SP', color: '#be123c', font: 'tracking-tight' },
    owner: 'Karthik S.', role: 'Founder', image: SCENES.counter,
    quote: 'I finally know which items make money and which just sit on the shelf. Reordering is based on numbers now, not memory.',
    metrics: [['-27%', 'dead stock in 3 months'], ['1,200+', 'parts on the system'], ['9:30 am', 'daily stock report']],
    before: 'Stock in a notebook, fitting jobs billed separately, and no idea what was running low until a customer asked.',
    changed: 'Parts, fitting jobs and invoices share one stock list. A low-stock report arrives every morning by email.',
    after: 'Karthik reorders twice a month from the report and has cleared most of his slow movers.',
  },
];
